module.exports = __webpack_public_path__ + "static/media/profi.98cb4154.svg";